module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('v-card', {
      key: post.oembed
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(post.oembed)
      }
    })])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d70902e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/InfluencerSearch/InfluencerPostsModal.vue
// module id = 1998
// module chunks = 0